package com.nonopn.skywatcher.common.app.pages.scan

import com.nonopn.skywatcher.app.utils.safeLaunch
import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.common.app.pages.administrators.UserMode
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import eu.codlab.viewmodel.StateViewModel

private const val Millis = 1000.0

@Suppress("TooManyFunctions")
class ScanQrContentModel(
    private val thunderDetection: ThunderDetectionWithMetadata,
    private val currentApi: ApiInterface,
    private val userOrAdminMode: UserMode
) : StateViewModel<ScanQrContentModelState>(ScanQrContentModelState()) {

    fun inviteToSentinel(uuid: String, onSuccess: () -> Unit, onError: () -> Unit) {
        safeLaunch {
            if (states.value.isWaitingAlertDismiss || states.value.isInviting) return@safeLaunch

            updateState { copy(isInviting = true) }

            try {
                currentApi.addUser(
                    thunderDetection,
                    uuid = uuid,
                    isAdministrator = UserMode.Admin == userOrAdminMode
                )

                updateState { copy(isInviting = false) }
                onSuccess()
            } catch (err: Throwable) {
                updateState {
                    copy(
                        invitationError = err,
                        isWaitingAlertDismiss = true,
                        isInviting = false
                    )
                }

                onError()
            }
        }
    }

    fun commitAlert() = safeLaunch {
        updateState { copy(isWaitingAlertDismiss = false) }
    }
}
